import React, {useState, useRef, useEffect, useMemo, Fragment} from 'react';
import Link from 'next/link';
import { v4 as uuidv4 } from 'uuid';
import {useRouter} from 'next/router';
import {UserIcon, VisDiv,  Loading } from '..';
import {useStateContext} from '../../context/StateContext';
import { addValueForDropdown, userLogCheck, unique, nPostazione, euro, percentage, twoDecimals, htmlInfoLine  } from '../../lib/utils'; 
import {useCreateReplace, useDeleteDocument} from '../../hooks/mutations'
import Swal from "sweetalert2"
import { IoIosAddCircleOutline } from 'react-icons/io';
import PromiseQueue from 'p-queue'
import TrueFalseToggle from '../TrueFalseToggle';
import { useExpanded, useTable, useColumnOrder } from "react-table";
import RichTextEditor from '../RichTextEditor';

import { offerTableData } from '../../lib/offerTableData';
import TestButton from '../frontend_components/TestButton';


/**
 * CustomerProductsReport is a React component that renders a table with customer products offer data.
 * #offer
 * @param {object} data - props containing customerProducts, laws, nonConformities, templateRegisters, and customer
 * @param {object} offerFields - props containing offer fields data
 * @param {object} register - props containing register data
 * @param {object} currentRegister - props containing current register data from state context
 * @param {object} customerProducts - props containing customer products data
 * @param {object} nonConformities - props containing non-conformities data
 * 
 * @returns {JSX.Element} - a component that renders a table with customer products offer data
 */
   const CustomerProductsReport = ({data, testString, offerFields, register, customerProducts, nonConformities}) => {

    const {register: currentRegister} = useStateContext()
       
      //console.log("IN CONSOLE OFFER REPORT DATA", data)

      //DATA PREPARATION ______

      const [workingData, setWorkingData] = useState([])
      const [loading, setLoading] = useState(false)


     //===========
     useEffect(()=>{
      setLoading(true)
      setWorkingData(offerTableData(data))
      setLoading(false)
  },[data])
     
     const testFunction = () => {
         console.log("data Customer Products", data)
         
     }
     const value = (cellValue, valueType) => {

      if(valueType == "PERCENTAGE") return percentage(cellValue)
      if(valueType == "CURRENCY") return euro(cellValue)
      if(valueType == "TWODECIMALS") return twoDecimals(cellValue)
      if(valueType == "RICHEDITOR") return  <RichTextEditor existingDoc={cellValue} readOnly={true}/>

      return cellValue
     }
     const hiddenColumns = ["law"]
     const values = useMemo(() => (tableData(workingData, hiddenColumns)?.data),[workingData]);

     const columns = useMemo(
       () => (tableData(workingData, hiddenColumns)?.columns),[workingData]
     );


 
    const consoleData = {
       workingData,
       offerFields,
       values,
       columns,
       data,
       register, 
       customerProducts, 
       nonConformities,
       currentRegister,
       testString
     }
     useEffect(()=>{
      tableData(workingData, hiddenColumns)?.hideColumns.forEach(x=>toggleHideColumn(x,true))
     },[workingData])
 
 
     const { getTableProps, getTableBodyProps, toggleHideColumn, headerGroups, rows, prepareRow } = 
     useTable({ columns, data:values });

   if(loading) return <Loading/> 
   return (
     <div className="App">
      {/* <VisDiv rules={[true]}><button onClick={testFunction}>test offer report</button></VisDiv> */}
      <TestButton consoleData={consoleData} buttonId='wlksmlqwkmsqwklms' message={"test offer report"}/>
       <div className="container">
         <table {...getTableProps()}>
           <thead>
             {headerGroups.map?.((headerGroup, index) => (
               <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                 {headerGroup.headers.map?.((column, index) => {
                   const isCost = column?.isCost
                   const costsColor = isCost ? {backgroundColor:"red"} : {backgroundColor:"#385391"}
                   return (
                   <th key={index} style={{fontSize:"12px", color:"white",...costsColor }} {...column.getHeaderProps()}>
                     {column.render("Header")}
                   </th>
                 )})}
               </tr>
             ))} 
           </thead>
           <tbody {...getTableBodyProps()} style={{fontSize:"12px"}}>
             {rows.map?.((row, index) => {
               const rowColour = () => { 
                if(register?.label == "SEGNALETICA" && currentRegister) {
                  const offerField = data?.find(x=>x?._id == row?.original?._id)
                  if(offerField?.registerId == currentRegister?._id && !offerField?.labourProduct) {
                    //console.log("row color lsfjilejf", {register, currentRegister, row, data, findInData: offerField})
                    // green  return index % 2 ? "#96f296":"#baf7ba"
                    return index % 2 ? "#ffff99":"#fafac3"
                  
                  }
                  
                  return index % 2 ? "white":"#f3f4f3" 
                }
                 return index % 2 ? "white":"#f3f4f3" 
                }
               prepareRow(row);

               return (
                 <Fragment key={index}>
                  
                   <tr style={{backgroundColor: rowColour()}} {...row.getRowProps()}  >
                     {row.cells.map?.((cell, index) => {
                        const valueType = cell?.column?.valueType
                        const groupedOfferField = data?.find(x=>x?._id == cell?.row?.original?._id)
                        const findOfferFields = groupedOfferField?.deviceIds?.map((x)=>{
                          const findOfferField = offerFields?.find(y=>y?.deviceId == x)
                          return findOfferField
                        })
                        const customerProduct = !Array.isArray(customerProducts) ? undefined : customerProducts?.find(x=>x?._id == groupedOfferField?.customerProductId)
                        const nonConformity = !Array.isArray(nonConformities) ? undefined : nonConformities?.find(x=>x?._id == groupedOfferField?.nonConformityId)
                        //#labourProducts
                        const cellValue = (cell?.row?.original?.labourProduct && cell?.column?.id == "quantity") ? 1 : value(cell?.value, valueType)
                        const cellColour = () => {
                          const excludeIds = [
                            "34a1fc10-375b-4238-bd37-3a339a70243a",
                            "2b5fda99-211a-4512-b02b-085199dccbf9",
                            "d0b3f302-92ef-423b-bd9f-709c35e6dde2"
                          ]
                          const isExcluded = excludeIds?.some?.((x)=>x == cell?.row?.original?.allowZero)
                          if(cell?.row?.original?.allowZero) return ({})
                          if(+cell?.value <= 0){return ({backgroundColor:"red"})}
                          return ({})
                        }
                        const onCellClick = () => {
                          console.log("offer cell click edkpqwkdpoqwkd", {cell, cellValue, offerField: groupedOfferField, findOfferFields, customerProduct, nonConformity})
                            Swal?.fire({
                                position: 'center',
                                icon: 'info',
                                html: `
                                  <div style="text-align: center; border: 1px solid lightgrey; border-radius: 10px; padding: 20px;">
                                      ${htmlInfoLine({value: groupedOfferField?.customerProduct, title: "PRODOTTO INTERNO"})}
                                      ${htmlInfoLine({value: groupedOfferField?.nonConformity, title: "NON CONFORMITA'"})}
                                  </div>
                                  `,
                                width: "80%",
                                showConfirmButton: true,
                                //timer: 1500
                              })
                              
                        }
                       return(
                       <td onClick={onCellClick} key={index} style={{...cellColour(), borderRight: 1, borderRightColor: "#d1c5c5", borderRightStyle: "dotted"}}  {...cell.getCellProps()}> {cellValue} </td>
                     )})}
                   </tr>
                 </Fragment>
               );
             })}
           </tbody>
         </table>
       </div>
     </div>
   )
     }

export default CustomerProductsReport


/**
 * A function that takes an array of objects and an array of column names to hide, and returns an object with columns and data suitable for use in a react-table.
 * @param {array} workingData - An array of objects where each object contains the data for a single row in the table.
 * @param {array} hiddenColumns - An array of column names to hide in the table.
 * @returns {object} - An object with columns and data suitable for use in a react-table.
 */
export const tableData = (workingData, hiddenColumns=[]) => {
  //console.log("WORKING DATA IN TEABLE DATA", workingData)
  const tableValues = !workingData ? [] : workingData?.map?.((x)=> x?.flat().map?.((item)=>({[item?.accessor]: item?.value})).reduce(((r, c) => Object.assign(r, c)), {}))

  const uniqueTableDataArray = unique("accessor",workingData?.flat(2))
  const tableColumns = uniqueTableDataArray.map?.((item => {
    return({
      accessor: item?.accessor,
      Header: item?.Header,
      //order: item?.order,
      isCost: item?.isCost,
      minWidth: item?.minWidth,
      labourProduct: item?.labourProduct,
      valueType: item?.valueType
  })}))

  const doc = {
       columns: tableColumns,
       data: tableValues,
       hideColumns: [
        "_id",
        "allowZero",
        "labourProduct",
        "nonConformity",
        "customerProduct", 
        ...hiddenColumns],
       }
    return doc
}